import React from 'react';
import { Link, graphql } from 'gatsby';
import Img from 'gatsby-image';
import Layout from '../components/Layout';
import { Section } from '../components/section';
import { Panel } from '../kit/panel';
import { GiftsShowcase } from '../views/gifts-showcase';
import { ContactForm } from '../views/contact-form';
import PreviewCompatibleImage from '../components/PreviewCompatibleImage';
import { Contacts } from '../components/contacts';

export default class IndexPage extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <Layout>
        <section style={{ position: 'relative' }}>
          <Img
            css={{ top: 0, left: 0, right: 0, bottom: 0 }}
            style={{
              position: `absolute`,
              width: '100%',
              height: '100%',
              filter: 'brightness(0.7)',
            }}
            fluid={data.mainImage.childImageSharp.fluid}
          />
          <div className="container">
            <div
              style={{
                padding: '2rem 1rem 1rem',
              }}
            >
              <h4
                className="title is-3 is-size-4-mobile"
                style={{ color: '#fff', textShadow: '0 0 3px rgba(0, 0, 0, .4)' }}
              >
                <span>Букеты, цветочные подарки в Новосибирске.</span>
              </h4>
              <Panel
                style={{
                  position: 'relative',
                  top: '2rem',
                  overflow: 'hidden',
                }}
              >
                <div className="columns">
                  <div className="column has-text-centered-mobile">
                    Упрости себе выбор букета — подари букет месяца, на него есть скидка
                  </div>
                  <div className="column is-one-quarter has-text-right has-text-centered-mobile">
                    <Link to="/gift/bouquet-of-the-month" className="button is-primary">
                      Узнать больше
                    </Link>
                  </div>
                </div>
              </Panel>
            </div>
          </div>
        </section>
        <div>
          <Section>
            <div>
              <div className="columns">
                <div className="column is-one-quarter">
                  <div
                    style={{
                      borderRadius: '50%',
                      overflow: 'hidden',
                      maxWidth: '240px',
                      margin: '0 auto',
                    }}
                  >
                    <PreviewCompatibleImage fluid={data.sasha.childImageSharp.fluid} />
                  </div>
                </div>
                <div className="column">
                  <p className="content">
                    Привет, я Саша. Я могу сделать букет, дополнить твой подарок милыми мелочами или
                    помочь с подарком с нуля — найти нужный предмет и привести в дарительный вид. А
                    ещё я могу оформить свадьбу, фотосессию или другое событие.
                    <br />
                    <br />
                    Для мужчины подарок — это просто галочка, о которой легко забыть. Для женщин же
                    это искусство: удивить, впечатлить. Вместе с подарками женщины любят получать
                    ещё и эмоции. С этим пунктом я и хочу тебе помочь.
                    <br />
                    <br />
                    Дари эмоции! :)
                  </p>
                </div>
              </div>
            </div>
          </Section>
          <Section heading="Цветочные подарки" hasBackground>
            <GiftsShowcase />
            <div className="block" style={{ paddingBottom: '1rem' }}>
              Выбери цветочный комплимент, признание или подарок.
              <br />
              <br />
              <Link to="/gifts" className="button is-primary">
                Смотреть все цветочные подарки →
              </Link>
            </div>
            <div className="columns">
              <div className="column">
                <div>
                  <h6 className="title is-6">Заказ</h6>
                  <p>за 1-3 дня</p>
                </div>
              </div>
              <div className="column">
                <div>
                  <h6 className="title is-6">Оплата</h6>
                  <p>при получении, наличными или переводом на карту</p>
                </div>
              </div>
              <div className="column">
                <div>
                  <h6 className="title is-6">Предоплата</h6>
                  <p>за заказы дороже 2500р, 100%</p>
                </div>
              </div>
              <div className="column">
                <div>
                  <h6 className="title is-6">Доставка</h6>
                  <p>бесплатно по Новосибирску или самовывоз с Горского мкр</p>
                </div>
              </div>
            </div>
          </Section>
          <Section heading="Акции">
            <div className="block">
              <div className="columns">
                <div className="column">
                  <h6 className="title is-6">Букет месяца</h6>
                  <p>Я выбираю букет, который очень хочу сделать, а ты получаешь на него скидку.</p>
                </div>
                <div className="column">
                  <h6 className="title is-6">Оптовая скидка</h6>
                  <p>Больше букетов — меньше цена.</p>
                </div>
                <div className="column">
                  <h6 className="title is-6">Дружественная скидка</h6>
                  <p>
                    Пиши отзывы в соцсетях и рекомендуй Цвет Папоротника друзьям, и скидка 10% на
                    заказ у тебя в кармане.
                  </p>
                </div>
              </div>
            </div>
            <Link to="/promo" className="is-size-5">
              Узнать подробнее об акциях →
            </Link>
          </Section>
          <Section heading="Декор событий" hasBackground>
            Кроме букетов и подарков я занимаюсь оформлением мероприятий. Ты можешь заказать у меня
            декор свадьбы, дня рождения, фотосессии, открытия магазина, корпоратива и любого другого
            праздника и события.
            <Link
              to="/decor"
              style={{
                margin: '1rem -1.5rem 1rem',
                height: 200,
                overflow: 'hidden',
                position: 'relative',
                display: 'block',
              }}
            >
              <Img
                css={{ top: 0, left: 0, right: 0, bottom: 0 }}
                style={{
                  position: `absolute`,
                  width: '100%',
                  height: '100%',
                }}
                fluid={data.decorImage.childImageSharp.fluid}
              />
            </Link>
            <Link to="/decor" className="is-size-5">
              Узнать подробнее о декоре событий →
            </Link>
          </Section>
          <Section heading="Мастер-классы">
            Я провожу флористические мастер-классы. На них ты сам сделаешь свой букет или цветочную
            композицию. Организуй или запишись на доступный мастер-класс.
            <Link
              to="/workshops"
              style={{
                margin: '1rem -1.5rem 1rem',
                height: 200,
                overflow: 'hidden',
                position: 'relative',
                display: 'block',
              }}
            >
              <Img
                css={{ top: 0, left: 0, right: 0, bottom: 0 }}
                style={{
                  position: `absolute`,
                  width: '100%',
                  height: '100%',
                }}
                fluid={data.workshopsImage.childImageSharp.fluid}
              />
            </Link>
            <Link to="/workshops" className="is-size-5">
              Узнать подробнее о мастер-классах →
            </Link>
          </Section>
          <Section heading="Портфолио" hasBackground>
            <Link to="/portfolio" className="columns is-mobile">
              {data.portfolioImages.edges.map(({ node }) => (
                <div className="column" key={node.id}>
                  <Img fluid={node.fluid} />
                </div>
              ))}
            </Link>
            <Link to="/portfolio" className="is-size-5">
              Смотреть больше моих работ →
            </Link>
          </Section>
          <Section>
            <div className="columns">
              <div className="column">
                <h4 className="title is-4">Контакты</h4>
                <Contacts />
              </div>
              <div className="column">
                <h4 className="title is-4">Остались вопросы? Задай их мне!</h4>
                <ContactForm />
              </div>
            </div>
          </Section>
        </div>
      </Layout>
    );
  }
}

export const indexPageQuery = graphql`
  query UselessRootQuery {
    mainImage: file(relativePath: { eq: "main.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1392, maxHeight: 700, cropFocus: SOUTH) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    sasha: file(relativePath: { eq: "sasha.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 480, maxHeight: 480) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    decorImage: file(relativePath: { eq: "index-decor.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1392, maxHeight: 600, cropFocus: SOUTH) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    workshopsImage: file(relativePath: { eq: "index-workshops.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1392, maxHeight: 600, cropFocus: NORTH) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    portfolioImages: allImageSharp(
      limit: 4
      filter: {
        fluid: {
          originalName: {
            in: [
              "portfolio-gayduk-12.jpg"
              "portfolio-photoday-5.jpg"
              "portfolio-photoday-10.jpg"
              "portfolio-mashkiny-2.jpg"
            ]
          }
        }
      }
    ) {
      edges {
        node {
          id
          fluid(maxWidth: 636, maxHeight: 480) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
`;
